export default __webpack_public_path__ + "static/merch-banner-d2fd2ed58051bb2b7b5ee19df61a811c.png";